import {GridColDef, GridFilterItem} from "@material-ui/data-grid";
import {ServiceGridFilterInput} from "../features/services/components/ServicesAutoComplete";
import {ServiceChips} from "../features/services/components/ServiceChip";
import React from "react";
import {FeOrder} from "../features/orders/redux/types";
import {store} from "../redux/store";
import {selectServiceById} from "../features/services/redux/services.slice";

export const getServicesTableCell = (hide?: boolean): GridColDef =>( {
    hide,
    field: 'servicesIds',
    filterable: true,
    headerName: 'Services',
    width: 200,
    valueFormatter: (params) => {
      const order = params.row as FeOrder;
      const state = store.getState();
      return order.servicesIds.map(sId => {
          const service = selectServiceById(state, sId);
          return service?.name ?? ""
      }).join(", ")
    },
    filterOperators: [
        {
            label: "kann",
            value: "servicesIds",
            getApplyFilterFn: (filterItem: GridFilterItem) => {
                if (
                    !filterItem.columnField ||
                    !filterItem.value ||
                    !filterItem.operatorValue
                ) {
                    return null;
                }

                return (params): boolean => {
                    const workerServiceIds = params.value as string[];
                    const searchedServicesIds = filterItem.value as string[];
                    return searchedServicesIds.every((ssId) => workerServiceIds.includes(ssId))
                };
            },
            InputComponent: ServiceGridFilterInput,
        }
    ],
    renderCell: (params) => (
        <ServiceChips
            serviceIds={params.value as string[]}
            initialAmount={4}
        />
    )
})
